import { create } from "zustand";
import { useRequestStore } from "../BackendStore";
import {
  Announcement,
  AnnouncementsResponse,
  AnnouncementUserInteraction,
  AnnouncementUserInteractionRequest
} from "../../Contracts/Announcement";
import { preloadImage } from "../../Utils/ImageUtils";

const getAnnouncementUrl = "/v2/announcement?appName=payments";
const registerAnnouncementUserInteractionUrl = "/v2/announcement-user-interaction?appName=payments";

interface AnnouncementState {
  announcement?: Announcement;
  isLoading: boolean;
  getAnnouncement: (getAccessTokenSilently: any) => Promise<void>;
  registerInteraction: (
    getAccessTokenSilently: any,
    announcementId: string,
    action: AnnouncementUserInteraction
  ) => Promise<void>;
}

export const useAnnouncementStore = create<AnnouncementState>(set => {
  const { getRequest, postRequest } = useRequestStore.getState();

  const getAnnouncement = async (getAccessTokenSilently: any) => {
    set({ isLoading: true });
    try {
      const response = await getRequest<AnnouncementsResponse>(
        getAccessTokenSilently,
        getAnnouncementUrl
      );
      const announcement = response.data?.[0];
      if (announcement?.template_metadata && (announcement.template_metadata as any).image_url) {
        await preloadImage((announcement.template_metadata as any).image_url);
      }
      set({ announcement, isLoading: false });
    } catch (error) {
      console.error("Error fetching announcement", error);
      set({ isLoading: false });
    }
  };

  const registerInteraction = async (
    getAccessTokenSilently: any,
    announcementId: string,
    action: AnnouncementUserInteraction
  ) => {
    try {
      await postRequest<AnnouncementUserInteractionRequest, void>(
        getAccessTokenSilently,
        registerAnnouncementUserInteractionUrl,
        {
          announcement_id: announcementId,
          action
        }
      );
    } catch (error) {
      console.error("Error registering announcement interaction", error);
    }
  };

  return {
    isLoading: false,
    announcement: undefined,
    getAnnouncement,
    registerInteraction
  };
});
